import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from 'src/app/core/services/auth/auth.service';
import { SystemPages } from '../../shared/enums/routerPaths.enum';

export const SuperAdminGuard: CanActivateFn = () => {
  const authService: AuthService = inject(AuthService);
  const router: Router = inject(Router);

  const isSuperAdmin: boolean = authService.getIsSuperAdmin();

  if (!isSuperAdmin) {
    void router.navigateByUrl(SystemPages.USER_PROFILE);
  }

  return isSuperAdmin;
};
